// extracted by mini-css-extract-plugin
export default {"container":"LerJ4w mz-price-breakdown__item Pgrqvw","icon":"CRmJZx"};